import type { InvestmentSourceRole } from '@/types';

/**
 * Labels for the connections folded into one holding. "espelho" is the load-bearing one:
 * the mirror's balance is already inside the row total, so its line must never read as
 * extra money.
 */
export const INVESTMENT_ROLE_LABELS: Record<InvestmentSourceRole, string> = {
  PRIMARY: 'principal',
  MIRROR: 'espelho',
  ADDITIVE: 'adicional',
};

export const MIRROR_NOTE = 'O saldo do espelho já está contado no total — não é dinheiro a mais.';

export function institutionLabel(institution: string | null): string {
  return institution?.trim() || 'Instituição não informada';
}
